import {PageNotFoundComponent} from './pagenotfound/pagenotfound.component';
import {AccountDeletionComponent} from './public/account-deletion/account-deletion.component';
import {AdminGuard} from './shared/authguard/adminguard.service';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const appRoutes: Routes = [
  {path: '', redirectTo: '/agent', pathMatch: 'full'},
  {path: 'en/Terms02', component: AccountDeletionComponent},
  {path: 'agent', loadChildren: './agent/agent.module#AgentModule'},
  {path: 'admin__', loadChildren: './admin/admin.module#AdminModule', canLoad: [AdminGuard]},
  {path: '**', component: PageNotFoundComponent},
  {path: '404', component: PageNotFoundComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts